import { Slider } from './slider';
/**
 * SliderY component.
 */
export const SliderY = (options) => {
    return Slider(Object.assign(Object.assign({}, options), { orientation: 'vertical' }));
};
SliderY.props = Object.assign(Object.assign({}, Slider.props), { defaultPosition: 'left' });
//# sourceMappingURL=sliderY.js.map